// Firebase Analytics for Community Engagement
import { getAnalytics, logEvent } from 'firebase/analytics';

export function trackUserEngagement(eventName, eventParams) {
    const analytics = getAnalytics();
    logEvent(analytics, eventName, eventParams);
  }